import { render, staticRenderFns } from "./ticket_root_type_action_types.vue?vue&type=template&id=5382838a&scoped=true&"
import script from "./ticket_root_type_action_types.vue?vue&type=script&lang=js&"
export * from "./ticket_root_type_action_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382838a",
  null
  
)

export default component.exports